import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { tenantAPI } from '../api/client';
import DevicesCard from '../components/DevicesCard';
import PasswordCard from '../components/PasswordCard';
import ProfileCard from '../components/ProfileCard';
import { useAuth } from '../context/AuthContext';
import { useTenant } from '../context/TenantContext';
import { usePlanLabel } from '../lib/usePlans';
import './CustomerDashboard.css';

/** Overview for members and viewers. */
export default function CustomerDashboard() {
  const planLabel = usePlanLabel();
  const location = useLocation();
  const { user } = useAuth();
  const { tenant, role } = useTenant();
  const [memberCount, setMemberCount] = useState(null);

  useEffect(() => {
    tenantAPI.get().then((res) => setMemberCount(res.data.member_count)).catch(() => {});
  }, []);

  const stats = [
    { label: 'Your Role', value: role, icon: '🪪', color: '#667eea' },
    { label: 'Organization Plan', value: planLabel(tenant.plan), icon: '⭐', color: '#764ba2' },
    { label: 'Team Members', value: memberCount ?? '—', icon: '👥', color: '#f6ad55' },
    { label: 'Support Tickets', value: '2', icon: '🎫', color: '#48bb78' },
  ];

  const recentOrders = [
    { id: '#ORD-001', date: '2026-10-01', amount: '₹299', status: 'Delivered' },
    { id: '#ORD-002', date: '2026-09-28', amount: '₹199', status: 'Processing' },
    { id: '#ORD-003', date: '2026-09-25', amount: '₹299', status: 'Delivered' },
  ];

  return (
    <>
      {location.state?.success && <div className="tcx-success">{location.state.success}</div>}
      <p className="customer-welcome" style={{ color: '#4a5568', marginBottom: 16 }}>Welcome back, {user.name}!</p>

      <div className="customer-stats-grid">
        {stats.map((stat) => (
          <div key={stat.label} className="customer-stat-card" style={{ borderTopColor: stat.color }}>
            <div className="stat-icon">{stat.icon}</div>
            <div className="stat-value" style={{ textTransform: 'capitalize' }}>{stat.value}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>

      <div className="customer-sections">
        <section className="customer-section">
          <div className="section-header">
            <h3>Recent Orders</h3>
          </div>
          <table className="orders-table">
            <thead>
              <tr><th>Order ID</th><th>Date</th><th>Amount</th><th>Status</th></tr>
            </thead>
            <tbody>
              {recentOrders.map((order) => (
                <tr key={order.id}>
                  <td className="order-id">{order.id}</td>
                  <td>{order.date}</td>
                  <td className="amount">{order.amount}</td>
                  <td><span className={`status-badge ${order.status.toLowerCase()}`}>{order.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>

      <ProfileCard tenantName={tenant.name} />
      <PasswordCard />
      <DevicesCard />
    </>
  );
}
